import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import './Edit.css'; // Ensure you import your CSS file
import axios from "axios";
import Loader from "../Chargers/Loader";

function Edit() {
  document.title = "Station | Edit";
  const navigate = useNavigate();
  const location = useLocation();
  const StationEditData = location?.state?.StationEditData;
  let params = useParams();
  const StationID = params.cid;

  const [TitleName, setTitleName] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [LatitudePoints, setLatitudePoints] = useState("");
  const [LongitudePoints, setLongitudePoints] = useState("");
  const [Address, setAddress] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [loading, setLoading] = useState(true); // Set loading to true initially
  const [Imageurl, setImageurl] = useState([]);
  const [stationEditDataa, setstationEditDataa] = useState({});
  const [vendorData, setVendorData] = useState([]);
  const [selectedvendor, setselectedvendor] = useState([]);
  const [VendorAmount, setVendorAmount] = useState('');
    const [offers, setOffers] = useState([]);
    const [selectedOffer, setselectedOffer] = useState('');

  const fetchData = async () => {
    setLoading(true);
    const apiEndpoint = `${BaseURL}/station/${StationID}`;
    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });

      if (res && res.data) {
        setstationEditDataa(res?.data?.data); // Set the fetched station data
      } else {
        console.error("No station data found");
      }
    } catch (error) {
      console.error("Error fetching station data:", error);
    } finally {
      setLoading(false); // Stop loader when data is fetched
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    // Fetch countries on component mount
    const fetchOffersListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/offer`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setOffers(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchOffersListing();
  }, []);

  useEffect(() => {
    // Fetch countries on component mount
    const fetchVendorListing = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BaseURL}/user?userType=Vendor`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setVendorData(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
setLoading(false);
    fetchVendorListing();

  }, []);


  useEffect(() => {
    setLoading(true);
    if (stationEditDataa) {
      setTitleName(stationEditDataa?.station_name || "");
      setSelectedStatusType(stationEditDataa?.status || "");
      setLatitudePoints(stationEditDataa?.latitude || "");
      setLongitudePoints(stationEditDataa?.longitude || "");
      setAddress(stationEditDataa?.address || "");
      setImageurl(stationEditDataa?.station_images || []);
      setselectedvendor(stationEditDataa?.service_provider?.[0]?.service_provider_id[0]?._id);
      setLoading(false); 
       setVendorAmount(stationEditDataa?.service_provider?.[0]?.percentage);
       setselectedOffer(stationEditDataa?.offer_id?.[0]);

      // Set loading to false once data is loaded
      setLoading(false);
    }
  }, [stationEditDataa]);

  const handleTitleName = (e) => setTitleName(e.target.value);
  const handleFileChange = (e) => setSelectedFile(e.target.files[0] || "NA");
  const handleAddressChange = (e) => setAddress(e.target.value);
  const handleLongitudeChange = (e) => setLongitudePoints(e.target.value);
  const handleLatitudeChange = (e) => setLatitudePoints(e.target.value);
  const handleStatusType = (e) => setSelectedStatusType(e.target.value);
  const handleVendorName = (e) => {setselectedvendor(e.target.value); };
  const handlevendorAmount = (e) => {setVendorAmount(e.target.value);};
  const handleOfferChange = (e) => {setselectedOffer(e.target.value);};

  const EditStation = async () => {
    if (!StationEditData || !StationEditData._id) {
      console.error("Station ID is missing or StationEditData is invalid");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Station ID is missing.",
      });
      return;
    }
    const data = [
      {
        "service_provider_id": selectedvendor,
        "percentage": VendorAmount
      }
    ];
    let formData = new FormData();
    formData.append("station_name", TitleName);
    formData.append("address", Address);
    formData.append("latitude", LatitudePoints);
    formData.append("longitude", LongitudePoints);
    if(selectedOffer) {
      formData.append("offer_id", selectedOffer);
    }
    if (selectedvendor) {
      data.forEach((item, index) => {
        formData.append(`service_provider[${index}][service_provider_id]`, item.service_provider_id);
        formData.append(`service_provider[${index}][percentage]`, item.percentage);
      });
    }
     
    
    if (selectedFile) {
      formData.append("station_image", selectedFile);
    }
    // formData.append("status", selectedStatusType);

    // Show loader before API call
    Swal.fire({
      title: 'Updating Station...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      let response = await fetch(`${BaseURL}/station/${StationEditData._id}`, {
        method: "PUT",
        body: formData,
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      let responseData = await response.json();
      console.log("responseData", responseData);

      // Hide the loader
      Swal.close();

      if (responseData.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: responseData?.message,
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/stations`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `${responseData.message}`,
        });
      }
    } catch (error) {
      // Hide the loader
      Swal.close();

      console.log("Error in EditStation:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent the default form submission
    EditStation();
  };
  const handleRemoveImage = async (imageID) => {
    try {
      const response = await fetch(`${BaseURL}/station/delete-image/${imageID}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      const data = await response.json();
      if (data?.statusCode === 200) { // Adjusted to `data` for correct response format
        // alert("Image removed successfully!");
        fetchData(); // Refresh the data if needed
  
        // Remove the image from the UI
        const updatedImages = Imageurl.filter((image) => image._id !== imageID);
        setImageurl(updatedImages);
      } else {
        console.error('Failed to remove image from server');
      }
    } catch (error) {
      console.error('Error while removing the image:', error);
    }
  };
  
  

console.log("StationEditData", StationEditData);
console.log("stationEditDataa...........", stationEditDataa);
console.log("titlenameeeee", TitleName);
console.log("imageeeesss", Imageurl);
console.log("Offer.....", selectedOffer);

  return (
    <>
   
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <h1 className="page-title"></h1>
                <div className="portlet light bordered">
                  <div className="portlet-title row">
                    <div className="caption font-dark col-md-10">
                      <h4 className="caption-subject bold uppercase mx-3">
                        Edit Station
                      </h4>
                    </div>
                    <div className="caption font-dark col-md-2">
                      <h5 className="caption-subject bold uppercase mx-3">
                        <button className="btn btn-success"  onClick={() => navigate(-1)}>
                          Back
                        </button>
                      </h5>
                    </div>
                  </div>
                  {loading ? (
        <Loader/> // Rotating loader display
      ) : (
                  <div className="portlet-body mx-3">
                    <hr style={{ marginTop: "-5px" }} />
                    <div className="row">
                      <div className="col-sm-12">
                        <form
                          className="form-horizontal"
                          encType="multipart/form-data"
                          role="form"
                          method="post"
                          style={{ marginTop: "-20px" }}
                          onSubmit={handleSubmit}
                        >
                          <div className="form-group">
                            <div className="row">
                              <label htmlFor="name_id" className="col-sm-2 control-label">
                                Station Name
                              </label>
                              <div className="col-sm-6">
                                <input
                                  onChange={handleTitleName}
                                  value={TitleName}
                                  className="form-control"
                                  id="name_id"
                                  name="station_name"
                                />
                              </div>
                              <span className="col-sm-4 control-label"></span>
                            </div>
                          </div>

                          <div className="form-group">
                            <div className="row">
                              <label htmlFor="latitude_id" className="col-sm-2 control-label">
                                Latitude
                              </label>
                              <div className="col-sm-6">
                                <input
                                  onChange={handleLatitudeChange}
                                  className="form-control"
                                  id="latitude_id"
                                  name="latitude"
                                  value={LatitudePoints}
                                />
                              </div>
                              <span className="col-sm-4 control-label"></span>
                            </div>
                          </div>

                          <div className="form-group">
                            <div className="row">
                              <label htmlFor="longitude_id" className="col-sm-2 control-label">
                                Longitude
                              </label>
                              <div className="col-sm-6">
                                <input
                                  onChange={handleLongitudeChange}
                                  className="form-control"
                                  id="longitude_id"
                                  name="longitude"
                                  value={LongitudePoints}
                                />
                              </div>
                              <span className="col-sm-4 control-label"></span>
                            </div>
                          </div>

                          <div className="form-group">
                            <div className="row">
                              <label htmlFor="address_id" className="col-sm-2 control-label">
                                Address
                              </label>
                              <div className="col-sm-6">
                                <textarea
                                  onChange={handleAddressChange}
                                  value={Address}
                                  className="form-control"
                                  id="address_id"
                                  name="address"
                                />
                              </div>
                              <span className="col-sm-4 control-label"></span>
                            </div>
                          </div>
                          <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Service Provider
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleVendorName}
                                className="form-control"
                                id="name_id"
                                name="name"
                                value={selectedvendor}
                              >
                                <option value="0">Select Vendor</option>
                                {vendorData?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.name}
                                    </option>
                                  );
                                })}
                                </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        {
selectedvendor  &&  
  <>
  <div className="form-group">
  <div className="row">
    <label htmlFor="statusType" className="col-sm-2 control-label">
    Vendor Percentage
    </label>
    <div className="col-sm-6">
      <input
        onChange={handlevendorAmount}
        value={VendorAmount}
        type="number"
        className="form-control"
        id="statusType"
        name="statusType"
      />
   
  
    </div>
    <span className="col-sm-4 control-label"></span>
  </div>
</div>
</>
}
<div className="form-group">
  <div className="row">
    <label htmlFor="name_id" className="col-sm-2 control-label">Offer</label>
    <div className="col-sm-6">
      <select 
        type="file"
        onChange={handleOfferChange}
        className="form-control"
        id="name_id"
        name="name"
        value={selectedOffer}
         // Enable multiple file selection
      >
          <option value="0">Select Offer </option>
                                {offers?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                        );
                                })}

        </select>
            <div>
      
      </div>
    </div>
    <span className="col-sm-4 control-label"></span>
  </div>
</div>

                          <div className="form-group">
  <div className="row">
    <label htmlFor="file_id" className="col-sm-2 control-label">
      Image
    </label>
    <div className="col-sm-6">
      <input
        type="file"
        onChange={handleFileChange}
        className="form-control"
        id="file_id"
        name="station_image"
      />
    </div>
    <div className="col-sm-4 control-label">
  {/* Show image previews if an array of images is available */}
  {Array.isArray(Imageurl) && Imageurl.length > 0 && (
    <div
      style={{
        display: 'flex',
        flexWrap: 'nowrap',  // No wrapping to ensure horizontal alignment
        // overflowX: 'auto',   // Add scroll if images overflow horizontally
        marginLeft: '180px',
      }}
    >
      {Imageurl.map((image, index) => (
      <div
      style={{
        display: 'flex',
        flexWrap: 'nowrap', 
        marginLeft: '180px',
      }}
    >
      {Imageurl.map((image, index) => (
        <div key={image._id} style={{ marginRight: '10px', position: 'relative' }}>
          <img
            src={image?.imageURL}
            alt={`Image ${index}`}
            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
          />
          <a
            href="javascript:void(0)"
            onClick={(e) => {
              e.preventDefault();
              handleRemoveImage(image._id); // Pass the unique image ID
            }}
            style={{
              position: 'absolute',
              top: '5px',
              right: '5px',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              fontSize: '18px',
              color: 'red',
              textDecoration: 'none',
            }}
          >
            ✕
          </a>
        </div>
      ))}
    </div>
    
      ))}
    </div>
  )}

  {/* Show selected file name if a new file is selected */}
  {selectedFile && typeof selectedFile !== 'string' && (
    
    <span>{`Selected File: ${selectedFile?.name?selectedFile?.name : ""}`}</span>
  )}
</div>

  </div>
</div>


                           <div className="form-group">
                            <div className="col-sm-offset-2 col-sm-8 add-class">
                              <button
                                type="submit"
                                className="btn btn-success"
                              >
                                Update Station
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                   )}
                </div>
              </div>
            </div>
          </div>
        </div>
     
    </>
  );
}

export default Edit;
